import type { FaireProductEntity } from "../../entity_types/product";

export const p_5aufveuesb: FaireProductEntity = {
  token: "p_5aufveuesb",
  type: "product",
  name: "Rufia - 5 Pairs Unisex Bohemian Wool Blend Socks",
  brandToken: "b_qrthtbpuwu",
  brandName: "Funkyrel® Atzbranding Limited",
  imageUrl:
    "https://cdn.faire.com/fastly/8592389b0f0d7992bc4246a9b3cb6b5c942baf55e2e54e82390bfcb2d692861e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac1ff312d71e8db068244ed712b03cb2381eba60e43fef5b596ee93677f2f3d1.jpeg",
    "https://cdn.faire.com/fastly/b1823e5a7fd24e08a7f449649cbd86392608d8b9872dc5050ba9ca225a05df95.jpeg",
    "https://cdn.faire.com/fastly/3fc547f01dc39c896a75893519750d50131b66567a7e24bcfe3a18e2dbd7a9f0.jpeg",
    "https://cdn.faire.com/fastly/8e8a68dc950e1dc719296c6bb4866d6cfa45470da05c44fed59df57ab22892c5.jpeg",
    "https://cdn.faire.com/fastly/8c7767ab4b19023f716f6b79641f66435c5c8daa841a86133b4fd19aa9222cdd.jpeg",
    "https://cdn.faire.com/fastly/d78ae230e791a8eec3f122b1037ae5c50b21424392fbcf0f151f3e05cf607bf0.jpeg",
    "https://cdn.faire.com/fastly/6d0985d4ac3568e9d5d3b1012507517b5f8cb426e4d919a84e99cf2ecb80749a.jpeg",
    "https://cdn.faire.com/fastly/93b1a1e017c7361c8636d1ff315201e5950478c8262f789e8e87a3beb72bf2e0.jpeg",
    "https://cdn.faire.com/fastly/fce49fb3ec6c6d7245014b89f03daff128d35f1a471c899a634f9c7cd783775b.jpeg",
    "https://cdn.faire.com/fastly/9814758da0900d8c0dce71a0c462c8634071645ac1f7330ab6d379fcafebe9d6.jpeg",
    "https://cdn.faire.com/fastly/9b0b93dfea48a1a9123c02edf102ca0a1c90cdef8816f33866b053ac047b5d02.jpeg",
  ],
  priceDollars: 11,
  description:
    "A cosy set for every cold snap—the 5 Pairs Unisex Bohemian Wool Blend Socks feature nostalgic jacquard patterns in earthy palettes that suit all wardrobes. Soft, breathable, and ready to layer, this curated bundle is built for comfort and visual charm.\n• Five assorted pairs with retro geometric knit designs\n• Mid-calf crew fit with ribbed cuffs for stay-up wear\n• Soft wool-blend feel with seasonal warmth\n• Unisex-friendly styling—great for gifting or everyday layering\n• Ideal for boutiques, sock bars, or winter-themed displays\n\nFrom the Rufia collection—cosy classics in thoughtful textures and nostalgic palettes.\nBundle warmth. Gift texture.\n\nOur brand delivers UPC-coded, retail-ready products, crafted for excellence and immediate shelf placement. We offer highly flexible minimum order quantities (MOQ) to meet your needs. For inquiries, our responsive customer service ensures seamless support.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:31.997Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
